import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styles from './style.module.css';

const Order = ({ order, orderDate, orderStatuses }) => {
  let history = useHistory();

  return (
    <div
      tabIndex="0"
      onKeyPress={(event) =>
        event.key === 'Enter' ? history.push(`/pharmacy/dashboard/order/${order.order_id}`) : null
      }
      onClick={() => history.push(`/pharmacy/dashboard/order/${order.order_id}`)}
      className={`${styles.box_container} ${styles.orderRow} coop-l-row`}
      key={order.order_id}>
      <div className="coop-l-column coop-l-all-12 coop-l-medium-6">
        <h2 className={styles.list_title}>Order #{order.order_id}</h2>
        <p className={`${styles.list_subtitle} coop-t-regular`}>
          Order placed on {moment(orderDate).format('DD MMMM YYYY')}
        </p>
      </div>
      <div className="coop-l-column coop-l-all-12 coop-l-medium-6">
        <p
          className={`${styles.order_status_label}`}
          style={{
            backgroundColor: orderStatuses[0].background_colour,
            color: orderStatuses[0].text_colour,
          }}>
          {orderStatuses[0].short_description}
        </p>
      </div>
    </div>
  );
};

export default Order;
